import { mapState } from "vuex";
import * as Sentry from "@sentry/vue";

export default {
  data() {
    return {
      fetch_data: this.$route.params,
      input_type: "password",
      show_password: false,
      message: null,
      lemniskCbExecuted: false,
      unleashEnabled: false,
    };
  },

  methods: {
    back() {
      let backRoute = null;
      /*
       * clear TimerInterval
       * */
      if (this.saved_timerInterval) clearInterval(this.saved_timerInterval);

      if (this.saved_userStatus) backRoute = "redirect-to-website";
      else backRoute = "home";
      if (this.fetch_data.back && this.fetch_data.back !== this.$route.name)
        backRoute = this.fetch_data.back;

      if (this.$route.query.login_challenge)
        this.$router.push(
          {
            name: backRoute,
            params: this.$route.params,
            query: { login_challenge: this.$route.query.login_challenge },
          },
          () => {}
        );
      else
        this.$router.push(
          { name: backRoute, params: this.$route.params },
          () => {}
        );
    },

    toggle_password() {
      this.show_password = !this.show_password;
      if (this.show_password) this.input_type = "password";
      else this.input_type = "text";
      return this.input_type;
    },

    parsePhonenumber(phone) {
      let phone_data = {};
      phone_data.isdcode = phone.substring(0, 3);
      phone_data.phone_number = phone.substring(3, phone.length);

      return phone_data;
    },

    formatPhoneNumber(value) {
      let valueWithoutSpaces = value.trim().split(" ").join("");
      this.fetch_data.mobile = valueWithoutSpaces;
      this.$forceUpdate();
    },

    handleCallbackIfEventFails(cb, identifier) {
      // If even after 2seconds, lemnisk doesn't call our callback function
      // Call the callback function manually after waiting
      setTimeout(() => {
        if (!this.lemniskCbExecuted) {
          console.log(
            `**Lemnisk failed to callback *${identifier}* within 100ms`
          );
          Sentry.withScope((scope) => {
            scope.setTag("pageUrl", window.location.href);
            scope.setTag("Application", "ACCOUNTS");
            Sentry.captureMessage(`Event failed to send ${identifier}`, {
              level: "error",
            });
          });
          cb();
        }
      }, 2000);
    },
    clearError() {
      this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
        msg: null,
        errorCode: 0,
      });
    },
  },

  computed: {
    /*
     * get timeInterval value from store
     * */
    ...mapState("users", {
      saved_timerInterval: "timerInterval",
    }),
  },
};
